import { Map } from 'immutable';
import defaultDialogReducer from '../../defaultDialogReducer';
import {dialogsNames} from '../../../enums/dialogsNames';

let defaultState = {
  loading: false,
  show: false,
  items: null,
  kitTypeId: null,
};

export default function(state = Map(defaultState), action) {
  switch (action.type) {

    default:
      return defaultDialogReducer(state, action, dialogsNames.CREATE_QPL_TEST_FIELD_DIALOG, defaultState);
  }

}
